import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { serviceSettingsRoute } from '../route';

import { eventsValidateSearchSchema } from './helpers/eventsValidateSearchSchema';

export const eventsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/events',
	component: lazyRouteComponent(() => import('./EventsPage'), 'EventsPage'),
	validateSearch: eventsValidateSearchSchema,
});
